import { Search } from './Search';
import type { SearchQuery } from './model';
import { useSearch } from './useSearch';
import layout from '../../ui/layout.module.css';

/**
 * §8's Search page. A `<div>` rather than a `<main>` — the shell owns that landmark, and two of them is
 * a bug.
 *
 * The whole query comes in as a prop from the route, so this screen holds no search state at all: a
 * filter change is a navigation, and React re-renders it with a new `query`. That is why there is no
 * "apply" button anywhere on the page.
 */
export function SearchView({ query }: { readonly query: SearchQuery }) {
  return (
    <div className={layout.wide}>
      <Search binding={useSearch(query)} />
    </div>
  );
}
